import axios from 'axios';

const httpClient = axios.create({
  baseURL: 'https://courses.emstell.com/course-app/api/',
});

// httpClient.defaults.headers.common['X-localization'] = 1;
httpClient.interceptors.request.use(function (config) {
  const locale = localStorage.getItem('locale');
  config.headers['X-localization'] = locale && locale == 'ar' ? 2 : 1;
  return config;
});

// httpClient.interceptors.response.use((response) => {
//   if (
//     response.data &&
//     response.headers['content-type'] === 'application/json'
//   ) {
//     response.data = camelizeKeys(response.data);
//   }
//   return response;
// });

// httpClient.interceptors.request.use((config) => {
//   const newConfig = { ...config };

//   if (newConfig.headers['Content-Type'] === 'multipart/form-data')
//     return newConfig;

//   if (config.params) {
//     newConfig.params = decamelizeKeys(config.params);
//   }

//   if (config.data) {
//     newConfig.data = decamelizeKeys(config.data);
//   }

//   return newConfig;
// });

export default httpClient;

// Response Resolver
export const resolve = async (promise) => {
  const resolved = {
    data: null,
    error: null,
  };

  try {
    resolved.data = await promise.data;
  } catch (e) {
    resolved.error = e;
  }

  return resolved;
};

export const getImageFullUrl = (url) => {
  const imageBaseUrl = 'https://courses.emstell.com/course-app/public/';
  return `${imageBaseUrl}${url}`;
};
